import React, { FC } from 'react'
import style from './PresenterControls.module.scss'
import { PresenterControlsProps } from './types'
import PresenterControlButton from '../PresenterControlButton'
import { iconName } from '../Icon/types'
import { Size } from '../GrowingIcon/types'
import classnames from 'classnames'

const PresenterControls: FC<PresenterControlsProps> = ({
  buttonStatus, onClickAudio,
  onClickSettings, onClickVideo,
  audioSource, isLocal,
  background = 'black',
  tooltipPosition
}) => {

  const {
    microphone = 'connected',
    telephone = 'disconnected',
    video = 'connected'
  } = buttonStatus || {}

  return (
    <div
      data-bdd='presenter-controls'
      className={classnames(style['presenter-controls'], {
        [style['presenter-controls--transparent']]: background === 'none'
      })}
    >
      {
        audioSource === 'telephone'
          ? <PresenterControlButton
            buttonBdd={telephone === 'connected' ? 'toggle-sound' : 'toggle-sound-disabled'}
            buttonIcons={{
              hidden: iconName.phoneSlash,
              enabled: iconName.phone,
              errored: iconName.phone,
              disabled: iconName.phone
            }}
            hasError={telephone === 'disconnected'}
            isHidden={telephone === 'hidden'}
            isDisabled={telephone === 'disabled'}
            onClick={onClickAudio}
            tooltipBdd={'tooltip-audio'}
            tooltipText={{
              hidden: `Unmute telephone`,
              enabled: `Mute telephone`,
              errored: `You are not dialed in. Click Settings for dial-in details.`
            }}
            size={Size.SMALL}
            showHaloByDefault={false}
            tooltipPosition={tooltipPosition}
          />
          : <PresenterControlButton
            buttonBdd={microphone === 'connected' ? 'toggle-sound' : 'toggle-sound-disabled'}
            buttonIcons={{
              hidden: iconName.microphoneSlash,
              enabled: iconName.microphone,
              errored: iconName.microphone,
              disabled: iconName.microphone
            }}
            hasError={microphone === 'error'}
            isHidden={microphone === 'hidden'}
            isDisabled={microphone === 'disabled'}
            onClick={onClickAudio}
            tooltipBdd={'tooltip-audio'}
            tooltipText={{
              hidden: `Unmute mic`,
              enabled: `Mute mic`,
              errored: `Your microphone is currently blocked by your browser. Please 'Allow' your microphone from the padlock icon in the address bar`
            }}
            size={Size.SMALL}
            showHaloByDefault={false}
            tooltipPosition={tooltipPosition}
          />
      }
      <PresenterControlButton
        buttonBdd={video === 'connected' ? 'toggle-video' : 'toggle-video-disabled'}
        buttonIcons={{
          hidden: iconName.videoSlash,
          enabled: iconName.video,
          errored: iconName.video,
          disabled: iconName.video
        }}
        hasError={video === 'error'}
        isHidden={video === 'hidden'}
        isDisabled={video === 'disabled'}
        onClick={onClickVideo}
        tooltipBdd={'tooltip-video'}
        tooltipText={{
          hidden: `Switch on camera`,
          enabled: `Switch off camera`,
          errored: `Your camera is currently blocked by your browser. Please 'Allow' your camera from the padlock icon in the address bar`
        }}
        size={Size.SMALL}
        showHaloByDefault={false}
        tooltipPosition={tooltipPosition}
      />
      {
        isLocal &&
        <PresenterControlButton
          buttonBdd='open-settings'
          buttonIcons={{
            hidden: iconName.settings,
            enabled: iconName.settings,
            errored: iconName.settings,
            disabled: iconName.settings
          }}
          hasError={false}
          isHidden={false}
          isDisabled={false}
          onClick={onClickSettings}
          tooltipBdd='tooltip-settings'
          tooltipText={{
            enabled: `Open Audio/Video Settings`
          }}
          size={Size.SMALL}
          showHaloByDefault={false}
          tooltipPosition={tooltipPosition}
        />
      }
    </div>
  )

}

export default PresenterControls
